import { useState, useEffect } from "react";
import { apiRequest } from "../apiRequest";


export const useReportsData = (recordID, reportType) => {
  const [data, setData] = useState();

  const getRecord = async function () {
    const record = await apiRequest(
      `${reportType === "solar" ? "/solar" : ""}/reports/${recordID}`,
      "GET",
      null
    );
   
    return record;
  };

  useEffect(() => {
    getRecord().then((response) => setData(response));

    return;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [recordID]);

  return data;
};
